import { Quote } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { Container, Eyebrow, BookButton, LLink } from "@/components/common";
import { Reveal, LineReveal, Stagger, Item } from "@/components/motion/Reveal";

export function DirectBenefits() {
  const { t } = useLang();
  return (
    <section data-testid="home-direct" className="bg-stone py-20 md:py-32">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Reveal><Eyebrow className="mb-6">{t.home.directEyebrow}</Eyebrow></Reveal>
            <LineReveal as="h2" lines={[t.home.directTitle]} className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-charcoal" />
            <Reveal delay={0.2} className="mt-10"><BookButton testId="direct-book-button" variant="primary" /></Reveal>
          </div>
          <Stagger className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-px bg-line">
            {t.home.directItems.map((it, i) => (
              <Item key={it.t} className="bg-stone p-8 md:p-10">
                <span className="font-mono text-[10px] text-terra tracking-[0.2em]">0{i + 1}</span>
                <h3 className="mt-4 font-serif text-2xl text-charcoal">{it.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/65">{it.d}</p>
              </Item>
            ))}
          </Stagger>
        </div>
      </Container>
    </section>
  );
}

export function Testimonials() {
  const { t } = useLang();
  return (
    <section data-testid="home-testimonials" className="bg-sand py-20 md:py-28">
      <Container>
        <Reveal><Eyebrow className="mb-10">{t.home.testimonialsEyebrow}</Eyebrow></Reveal>
        <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {t.home.testimonials.map((q) => (
            <Item key={q.a} className="flex flex-col">
              <Quote size={20} strokeWidth={1} className="text-terra" />
              <p className="mt-6 font-serif text-xl md:text-2xl leading-snug text-charcoal">“{q.q}”</p>
              <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-charcoal/50">{q.a} · {q.r}</p>
            </Item>
          ))}
        </Stagger>
      </Container>
    </section>
  );
}

export function ContactStrip() {
  const { t } = useLang();
  return (
    <section data-testid="home-contact-strip" className="bg-ink on-dark py-20 md:py-28 border-t border-white/5">
      <Container>
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div className="max-w-2xl">
            <Reveal><Eyebrow light className="mb-6">{t.home.contactEyebrow}</Eyebrow></Reveal>
            <LineReveal as="h2" lines={t.pages.homeHeadings.extras} className="font-serif text-3xl sm:text-4xl lg:text-6xl leading-[1.05] tracking-tight text-bone" />
          </div>
          <Reveal delay={0.2} className="flex flex-wrap gap-4">
            <LLink to="contact" data-testid="strip-rfp-cta" className="btn btn-light">{t.home.rfpCta}</LLink>
            <LLink to="corporate" data-testid="strip-corporate-cta" className="btn btn-ghost-light">{t.nav.corporate}</LLink>
          </Reveal>
        </div>
      </Container>
    </section>
  );
}
